// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { IRemoteLogMessageSender } from "@lib/logging/IRemoteLogMessageSender";
import { IRemoteLogMessageSenderFactory } from "@lib/logging/IRemoteLogMessageSenderFactory";
import { RemoteLogMessageSender } from "@lib/logging/RemoteLogMessageSender";
import { IMessageSender } from "@lib/messaging/IMessageSender";
import { NetworkSource } from "@lib/messaging/NetworkSource";

export class RemoteLogMessageSenderFactory implements IRemoteLogMessageSenderFactory
{
  private readonly messageSender: IMessageSender;

  constructor(messageSender: IMessageSender)
  {
    this.messageSender = messageSender;
  }

  createRemoteLogMessageSender(networkSource: NetworkSource): IRemoteLogMessageSender
  {
    return new RemoteLogMessageSender(this.messageSender, networkSource);
  }
}